/**
 * Column names the Files readers share (docs/pdlc/feasibility-files.md §4).
 * PURE. Header matching is the placement reader's (`columnIndex`), so a
 * header reads the same in every reader.
 */
import { columnIndex } from '../ooh/placements';

/** An ad network's own id for a screen. */
export const SCREEN_ID_HEADERS = [
    // The networks' own names, as their rows in DANI's location file carry them.
    'venue id', // Bulletin
    'gtvid', // GSTV
    'gtv id',
    'unique id', // Outfront
    'geopath panel id',
    'screen id',
    'screen_id',
    'screenid',
    'screen',
    'geopath id',
    'geopath',
    'geopath_id',
    'unit id',
    'unit_id',
    'unit number',
    'panel id',
    'panel_id',
    'display id',
    'device id',
    'location id',
    'location_id',
    'site id',
    'id',
];
/** The id the daily ad logs name a campaign placement by (Confluence OP/3623026689). */
export const TAB_ID_HEADERS = ['tab id', 'tabid', 'tab_id', 'tab'];
export const ADDRESS_HEADERS = ['address', 'street', 'street address', 'address 1', 'address1'];
export const CITY_HEADERS = ['city', 'town'];
export const STATE_HEADERS = ['state', 'st', 'province'];
export const ZIP_HEADERS = ['zip', 'zip code', 'zipcode', 'postal code', 'postal'];
export const FORMAT_HEADERS = ['format', 'media type', 'media format', 'type', 'unit type'];
export const VENUE_HEADERS = ['venue', 'venue name', 'location name', 'site name', 'name'];
export const MARKET_HEADERS = ['market', 'dma', 'dma name', 'market name', 'metro'];
export const START_HEADERS = ['start', 'start date', 'flight start', 'campaign start', 'begin'];
export const END_HEADERS = ['end', 'end date', 'flight end', 'campaign end', 'finish'];

export const colOf = (headers: string[], names: string[]) => columnIndex(headers, names);

/** A date cell as YYYY-MM-DD: ISO, or US month/day/year. Null when it is not a date. */
export function isoDateOf(text: string): string | null {
    const t = text.trim();
    const iso = t.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
    const us = t.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2}|\d{4})$/);
    const [y, m, d] = iso
        ? [Number(iso[1]), Number(iso[2]), Number(iso[3])]
        : us
          ? [Number(us[3].length === 2 ? `20${us[3]}` : us[3]), Number(us[1]), Number(us[2])]
          : [NaN, NaN, NaN];
    if (!Number.isFinite(y) || m < 1 || m > 12 || d < 1 || d > 31) return null;
    const date = new Date(Date.UTC(y, m - 1, d));
    if (date.getUTCMonth() !== m - 1) return null;
    return date.toISOString().slice(0, 10);
}
